import SimpleContainer from './SimpleContainer';
import NumericInput from './NumericInput';
import CheckboxInput from './CheckboxInput';
import { Taxpayer } from '../types';

interface OBBBAInputsProps {
	taxpayer: Taxpayer;
	updateInput: (value: string | number, id: keyof Taxpayer) => void;
	calculate: () => void;
}

function OBBBAInputs({ taxpayer, updateInput, calculate }: OBBBAInputsProps) {
	return (
		<>
			<SimpleContainer
				$rows={1}
				$columns={taxpayer.filing_status === 1 ? 2 : 1}
				$gridGap="1rem"
			>
				<CheckboxInput
					id="65_plus_1"
					name="Primary taxpayer is 65 or older"
					yes="1"
					no="0"
					onChange={updateInput}
					placeholder={String(taxpayer['65_plus_1'])}
					tooltip="Senior taxpayers may qualify for additional deductions under OBBBA."
				/>
				{taxpayer.filing_status === 1 ? (
					<CheckboxInput
						id="65_plus_2"
						name="Spouse is 65 or older"
						yes="1"
						no="0"
						onChange={updateInput}
						placeholder={String(taxpayer['65_plus_2'])}
						tooltip="Senior taxpayers may qualify for additional deductions under OBBBA."
					/>
				) : null}
			</SimpleContainer>
			<SimpleContainer $rows={1} $columns={2} $gridGap="1rem">
				<NumericInput
					id="overtime_income"
					format="shortDollar"
					name="Qualified Overtime Income"
					onChange={updateInput}
					onEnter={calculate}
					placeholder={taxpayer.overtime_income}
					tooltip="Income earned from overtime work. May qualify for special OBBBA deductions up to $12,500. This amount is included as a subset of ordinary income, and can be no higher than ordinary income."
				/>
				<NumericInput
					id="tips_income"
					format="shortDollar"
					name="Qualified Tips Income"
					onChange={updateInput}
					onEnter={calculate}
					placeholder={taxpayer.tips_income}
					tooltip="Tips received from service work. May qualify for special OBBBA deductions up to $25,000. This amount is included as a subset of ordinary income, and can be no higher than ordinary income."
				/>
			</SimpleContainer>
			<SimpleContainer $rows={1} $columns={1} $gridGap="1rem">
				<NumericInput
					id="auto_loan_interest"
					format="shortDollar"
					name="Qualified Auto Loan Interest Paid"
					onChange={updateInput}
					onEnter={calculate}
					placeholder={taxpayer.auto_loan_interest}
					tooltip="Interest paid on auto loans. May qualify for special OBBBA deductions up to $10,000."
				/>
			</SimpleContainer>
		</>
	);
}

export default OBBBAInputs;
